export namespace NBarclaycardApplePay {
    export enum EEndpoints {
        request = 'cyberSource/applePay_request',
        validate = 'cyberSource/applePay_validate',
        shipping = 'cyberSource/applePay_applyShipping',
        order = 'cyberSource/applePay_placeOrder'
    }

    export const methodCode = 'cybersource_applepay';

    export const version = 2;

    export const notAvailableMessage = 'Apple Pay is not available. Please select another payment method.';
}
